import { Check } from 'lucide-react';

export const OptionCards = ({ options = [], value, onChange, multiple = false, disabled = false, testIdPrefix = 'opt' }) => {
  const selected = multiple ? (Array.isArray(value) ? value : []) : value;
  const isSelected = (opt) => (multiple ? selected.includes(opt) : selected === opt);
  const toggle = (opt) => {
    if (disabled) return;
    if (multiple) onChange(isSelected(opt) ? selected.filter(v => v !== opt) : [...selected, opt]);
    else onChange(opt);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" role={multiple ? 'group' : 'radiogroup'}>
      {options.map((opt, i) => {
        const sel = isSelected(opt);
        return (
          <button
            type="button"
            key={`${opt}-${i}`}
            role={multiple ? 'checkbox' : 'radio'}
            aria-checked={sel}
            disabled={disabled}
            onClick={() => toggle(opt)}
            data-testid={`${testIdPrefix}-option-${i}`}
            className={`relative flex items-start justify-between gap-3 p-4 rounded-xl border-2 text-left transition-all duration-200 ${
              sel
                ? 'border-[#D4AF37] bg-[#FDFBF7] shadow-md ring-2 ring-[#D4AF37]/20'
                : 'border-slate-200 bg-white hover:border-slate-300 shadow-sm'
            } ${disabled ? 'cursor-not-allowed opacity-80' : 'cursor-pointer'}`}
          >
            <span className="text-sm font-medium text-slate-900 leading-snug">{opt}</span>
            <span className={`shrink-0 w-5 h-5 mt-0.5 ${multiple ? 'rounded-md' : 'rounded-full'} flex items-center justify-center transition-colors ${
              sel ? 'bg-[#D4AF37] text-white' : 'border-2 border-slate-300 bg-white'
            }`}>
              {sel && <Check className="w-3.5 h-3.5" strokeWidth={3} />}
            </span>
          </button>
        );
      })}
    </div>
  );
};
